export const parseQuery = (query:string) => {
    return Array.from(new URLSearchParams(query).entries())
        .reduce((query, tuple)=>{
            const [key,value]=tuple;
            query[key]=value;
            return query;
        }, {});
}
